import React from 'react';

import type { TagEntity } from '@schibsted/frapi-schema';

import { filterTagsOnType, makeTagTitle } from '../../articles/helpers.js';

const LOCATION_TAG_VALUES = ['Bergen', 'Trondheim'];

export const getLocationTagTitle = (tags: TagEntity[]) => {
  const locationTag = filterTagsOnType(tags, 'område').find((tag) =>
    LOCATION_TAG_VALUES.includes(makeTagTitle(tag.title) ?? ''),
  );

  return locationTag ? makeTagTitle(locationTag.title) : undefined;
};

const TeaserLocation: React.FC<{ tags: TagEntity[] }> = ({ tags }) => {
  const locationTitle = getLocationTagTitle(tags);

  return locationTitle ? <div className="location">{locationTitle}</div> : null;
};

export default TeaserLocation;
